import { mobileMenu, faqManager, initScrollAnimations, trackPageView } from '../lib';

export function initHealingPage(): void {
  console.log('Initializing healing page');

  // Initialize shared utilities
  mobileMenu.init();
  faqManager.init();
  initScrollAnimations();
  trackPageView();

  // Initialize countdown timer
  initCountdown();

  // Initialize active nav based on scroll
  initActiveNav();
}

function initCountdown(): void {
  const countdownElement = document.getElementById('countdown');
  if (!countdownElement) return;

  const countDownDate = new Date();
  countDownDate.setDate(countDownDate.getDate() + 7);
  countDownDate.setHours(23, 59, 59, 0);

  const countdownInterval = setInterval(() => {
    const now = new Date().getTime();
    const countDownTime = countDownDate.getTime();
    const distance = countDownTime - now;

    if (distance < 0) {
      clearInterval(countdownInterval);
      countdownElement.innerHTML = 'Offer expired';
      return;
    }

    const days = Math.floor(distance / (1000 * 60 * 60 * 24));
    const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((distance % (1000 * 60)) / 1000);

    const daysEl = document.getElementById('countdown-days');
    const hoursEl = document.getElementById('countdown-hours');
    const minutesEl = document.getElementById('countdown-minutes');
    const secondsEl = document.getElementById('countdown-seconds');

    if (daysEl) daysEl.textContent = days.toString();
    if (hoursEl) hoursEl.textContent = hours.toString();
    if (minutesEl) minutesEl.textContent = minutes.toString();
    if (secondsEl) secondsEl.textContent = seconds.toString();
  }, 1000);
}

function initActiveNav(): void {
  const sections = document.querySelectorAll('section[id]');
  const navLinks = document.querySelectorAll('.site-header-nav-link, .site-header-mobile-nav-link');

  window.addEventListener('scroll', () => {
    let current = '';
    sections.forEach((section) => {
      const sectionTop = (section as HTMLElement).offsetTop - 100;
      const sectionHeight = (section as HTMLElement).offsetHeight;
      if (window.scrollY >= sectionTop && window.scrollY < sectionTop + sectionHeight) {
        current = section.getAttribute('id') || '';
      }
    });

    navLinks.forEach((link) => {
      link.classList.remove('active');
      if (link.getAttribute('href') === `#${current}`) {
        link.classList.add('active');
      }
    });
  });
}

// Auto-initialize
if (typeof window !== 'undefined') {
  document.addEventListener('DOMContentLoaded', initHealingPage);
}
